import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import {
  DEFAULT_SUPPORT_CONTACT_EMAIL,
  resolveSupportContact,
  SUPPORT_CONTACT_PLATFORM_SETTING_KEY,
} from '@/lib/supportContact';

export const supportContactQueryKey = ['platform-settings', SUPPORT_CONTACT_PLATFORM_SETTING_KEY] as const;

const fetchSupportContact = async () => {
  const { data, error } = await supabase
    .from('platform_settings')
    .select('value')
    .eq('key', SUPPORT_CONTACT_PLATFORM_SETTING_KEY)
    .maybeSingle();

  if (error) {
    console.error('Failed to load support contact setting:', error);
    return resolveSupportContact(null);
  }

  return resolveSupportContact(data?.value);
};

export const useSupportContact = () => {
  const query = useQuery({
    queryKey: supportContactQueryKey,
    queryFn: fetchSupportContact,
    staleTime: 5 * 60 * 1000,
  });

  return {
    ...query,
    supportEmail: query.data?.email ?? DEFAULT_SUPPORT_CONTACT_EMAIL,
  };
};
